import { render, staticRenderFns } from "./StoreLoginSettings.vue?vue&type=template&id=16e53443&"
import script from "./StoreLoginSettings.vue?vue&type=script&lang=js&"
export * from "./StoreLoginSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports